import {ConfigurationInterpreter, DecisionKind} from '@viamedici-spc/configurator-ts';
import {fetchAll} from '../slices/productDataSlice';
import {selectSpcConfiguration, selectSpcSession} from '../selectors';
import {mergeSpcDecisions} from '../components/spc/util/spcUtils';
import {setInitialized} from '../slices/statusSlice';
import {spcExpliciteChoiceDecision} from '../util/values';

export const sessionMiddleware = store => next => async action => {
	const result = next(action);

	if (action.type === 'spc/startSpcSession/fulfilled' && action.meta.arg.instance === 'default') {
		const deploymentName = action.meta.arg.deploymentName;
		// console.log('sessionMiddleware spc/startSpcSession/fulfilled', action.meta.arg.instance, store.getState());

		// product data for the model
		await store.dispatch(fetchAll({useAsDefault: true, modelId: deploymentName, region: store.getState().status.region}));

		const spcSession = selectSpcSession(store.getState());
		const spcConfiguration = selectSpcConfiguration(store.getState());

		const currentDecisions = spcSession?.getDecisions(DecisionKind.Explicit);
		// loaded via own storage
		const storedDecisions = store.getState().configuration?.data?.projects[0]?.project?.decisions ?? [];
		// loaded via shortnumber Service
		let shortNumberDecisions = store.getState().shortNumber?.data?.loadedConfig?.configurationData?.decisions ?? [];
		shortNumberDecisions = shortNumberDecisions.map(dec => spcExpliciteChoiceDecision(dec.variableId, dec.featureValue));
		// merge loaded decisions

		//console.log('sessionMiddleware currentDecisions', storedDecisions, shortNumberDecisions);
		const loadedDecisions = mergeSpcDecisions(storedDecisions, shortNumberDecisions);
		//console.log('sessionMiddleware loadedDecisions', loadedDecisions);

		let defaultDecisions = store.getState().productData.defaults;

		// remove eventual circular base profile decision in LightProfile Configurator
		if (store.getState().status.family === 'LightProfile') {
			defaultDecisions = defaultDecisions.filter(decision => decision.attributeId.localId !== 'HS_CircularBaseProfile');
		}
		//console.log('sessionMiddleware ', store.getState().status.family, store.getState().status.mode);
		if ((store.getState().status.family === 'TheLine' && store.getState().status.mode === 'internal')) {
			//console.log('sessionMiddleware TheLine internal mode');
			//defaultDecisions = [];
		}

		//console.log('sessionMiddleware current, loaded, default decisions', currentDecisions, loadedDecisions, defaultDecisions);
		//let initialDecisions = currentDecisions;
		//if (currentDecisions && currentDecisions.length === 0) initialDecisions = mergeSpcDecisions(defaultDecisions, loadedDecisions);
		if ((store.getState().status.family === 'TheLine')) {
			// Workaround for TheLine
			const isAsymetric = defaultDecisions.find(decision => decision.attributeId.localId === 'HS_Construction' && decision.choiceValueId === 'Asymmetric') !== undefined;
			// initialDecisions = initialDecisions.filter(decision => decision.attributeId.localId !== 'HS_Construction' && decision.choiceValueId !== 'Asymmetric');
			//console.log('sessionMiddleware line  isAAsymmetric', isAsymetric);
			if (isAsymetric) {
				defaultDecisions = defaultDecisions.filter(decision => !decision.attributeId.localId.endsWith('_2'));
			}
		}

		let initialDecisions;
		if (loadedDecisions.length > 0) {
			if ((store.getState().status.family === 'TheLine')) {

				initialDecisions = mergeSpcDecisions(defaultDecisions, loadedDecisions);
				// Workaround for TheLine: remove Asymmetric from default decisions
				const isAsymetric = loadedDecisions.find(decision => decision.attributeId.localId === 'HS_Construction' && decision.choiceValueId === 'Asymmetric') !== undefined;
				// initialDecisions = initialDecisions.filter(decision => decision.attributeId.localId !== 'HS_Construction' && decision.choiceValueId !== 'Asymmetric');
				//console.log('sessionMiddleware line  isAsymetric', isAsymetric);
				if (isAsymetric) {
					initialDecisions = initialDecisions.filter(decision => !decision.attributeId.localId.endsWith('_2'));
				}

			} else {
				initialDecisions = loadedDecisions;
			}
		} else if (store.getState().status.family === 'Line') {
			initialDecisions = mergeSpcDecisions(defaultDecisions, loadedDecisions);
			initialDecisions = initialDecisions.filter(decision => !decision.attributeId.localId.endsWith('_2'));
		} else {
			initialDecisions = mergeSpcDecisions(defaultDecisions, loadedDecisions);
		}

		// console.log('sessionMiddleware initial decisions', initialDecisions);
		await spcSession.makeManyDecisions(initialDecisions, {
			type: 'KeepExistingDecisions',
			conflictHandling: {type: 'Automatic'}, //{type: 'Manual', includeConstraintsInConflictExplanation: true}
		}).then(
			() => console.log('sessionMiddleware initial decisions made'),
			error => console.error('sessionMiddleware initial decisions failed', error)
		);

		// init done
		store.dispatch(setInitialized({initialized: true}));
	}
	return result;
};
